// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__4f0Eu","noLongPress":"navy-modal_noLongPress__ms6yJ"};